(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/game-engine/assets/javascripts/utils/top-rank.js') >= 0) return;  svs.modules.push('/components/racing/game-engine/assets/javascripts/utils/top-rank.js');

'use strict';

const engineUtils = svs.racing.gameEngine.utils.engine;
const mathUtils = svs.racing.gameEngine.utils.math;

const rankIsSet = (value, rank) => (value & 1 << rank) > 0;
const toggleRank = (value, rank) => value ^ 1 << rank;
const getAutomaticReserve = participants => participants.reduce((prev, curr) => prev.oddsLatest < curr.oddsLatest ? prev : curr, {});
const rowToPositions = (row, numPositions, conditionFn) => {
  const positions = numPositions > 0 ? new Array(numPositions) : [];
  row.forEach((value, index) => {
    if (engineUtils.isPosition(value) && (conditionFn ? conditionFn(value) : true)) {
      for (let i = 0; i < numPositions; i++) {
        if (rankIsSet(value, i)) {
          if (!positions[i]) {
            positions[i] = [];
          }
          positions[i].push(engineUtils.indexToPosition(index));
        }
      }
    }
  });

  for (let i = 0; i < positions.length; i++) {
    positions[i] = positions[i] || undefined;
  }
  return positions;
};
const countSelectedRanks = row => row.reduce((accummulator, current) => engineUtils.isPosition(current) ? accummulator + mathUtils.countSetBits(current) : accummulator, 0);
const getLongestRow = (row, numPositions) => {
  const buildUniqueRows = positions => {
    let longestRow = 0;
    const buildRow = (rankIndex, currentRow) => {
      if (positions[rankIndex]) {
        for (let i = 0; i < positions[rankIndex].length && longestRow < numPositions; i++) {
          const currentValue = positions[rankIndex][i];
          let newRow;
          if (currentValue && !currentRow.includes(currentValue)) {
            newRow = currentRow.concat(currentValue);
          } else {
            newRow = currentRow.slice();
          }
          if (newRow.length > longestRow) {
            longestRow = newRow.length;
          }

          const maxPossibleLength = currentRow.length + (numPositions - rankIndex);
          if (maxPossibleLength <= longestRow) {
            continue;
          }

          if (longestRow >= numPositions) {
            return;
          }

          if (rankIndex + 1 < numPositions) {
            buildRow(rankIndex + 1, newRow);
          }
        }
      } else if (rankIndex + 1 < numPositions) {
        buildRow(rankIndex + 1, currentRow);
      }
    };
    buildRow(0, []);
    return longestRow;
  };
  const positions = rowToPositions(row, numPositions, () => true);

  return buildUniqueRows(positions);
};
const getUniqueRows = (row, numPositions) => {
  const buildUniqueRows = positions => {
    const allRows = [];
    const buildRow = (rankIndex, currentRow) => {
      for (let i = 0; i < positions[rankIndex].length; i++) {
        const currentValue = positions[rankIndex][i];

        if (!currentValue) {
          continue;
        }

        if (currentRow.includes(currentValue)) {
          continue;
        }

        const concatedRow = currentRow.concat(currentValue);
        if (rankIndex === numPositions - 1) {
          allRows.push(concatedRow);
        } else {
          buildRow(rankIndex + 1, concatedRow);
        }
      }
    };
    buildRow(0, []);
    return allRows;
  };
  const positions = rowToPositions(row, numPositions, () => true);
  if (positions.length === numPositions && !positions.includes(undefined)) {
    return buildUniqueRows(positions);
  }
  return [];
};
svs.racing.gameEngine.utils.topRank = {
  countSelectedRanks,
  getAutomaticReserve,
  rankIsSet,
  toggleRank,
  getLongestRow,
  getUniqueRows,
  rowToPositions
};

 })(window);